export default from './Bookings';



// WEBPACK FOOTER //
// ./src/containers/Bookings/index.js